import React from 'react'

import TabFechasCharts from './componentes/tabfechachart'

const Estadistica:React.FC =()=>{
    return<>
    <TabFechasCharts />
    </>
}

export default Estadistica